const routes = [{
        path: "/mydashboard",
        component: () =>
            import ("../../components/page/myTask/dashBoard.vue"),
        meta: { title: "首页" }, //首页
    },
    {
        path: "/mytask",
        component: () =>
            import ("../../components/page/myTask/myTask.vue"),
        meta: { title: "nav.taskTodo" }, //首页
        children: [{
            name: "auditProblemReportHandle",
            path: "auditProblemReportHandle/:reportId",
            component: () =>
                import ("@/components/page/storeFeedback/reportDetail_reportItem"),
            meta: { title: "common.audit", auditDialog: true }, //首页
        }, ],
    },
    {
        name: "auditSourcing",
        path: "auditLineSourcing",
        component: () =>
            import ("@/components/page/quotation-apply/sourcing-audit"),
        meta: { title: "common.audit", auditDialog: true }, //首页
    },
    {
        name: "auditProSourcing",
        path: "/auditProSourcing",
        component: () =>
            import ("@/components/page/quotation-apply/sourcing-pro-audit"),
        meta: { title: "common.audit", proAuditDialog: true }, //首页
    },
    {
        path: "/mytask-sfb",
        component: () =>
            import ("@/components/page/myTask/myTask-SFB"),
        meta: { title: "nav.taskTodoSFB" }, //首页
        children: [{
                name: "auditSourcing",
                path: "auditLineSourcing",
                component: () =>
                    import ("@/components/page/quotation-apply/sourcing-audit"),
                meta: { title: "common.audit", auditDialog: true }, //首页
            },
            {
                name: "auditProblemReportHandle",
                path: "auditProblemReportHandle/:reportId",
                component: () =>
                    import ("@/components/page/storeFeedback/reportDetail_reportItem"),
                meta: { title: "common.audit", auditDialog: true }, //首页
            },
        ],
    },
    {
        path: "/taskList",
        component: () =>
            import ("../../components/page/myTask/taskList.vue"),
        meta: { title: "nav.taskManagement" },
    },
    {
        path: "/qspiTodo",
        component: () =>
            import ("../../components/page/myTask/qspi.vue"),
        meta: { title: "QSPI待办任务" }, //首页
    },
    {
        path: "/nutritionTodo",
        component: () =>
            import ("../../components/page/myTask/nutrition.vue"),
        meta: { title: "Nutrition待办任务" }, //首页
    },
];

export default routes;